export enum SiteKeys {
  Alabama = 1,
  ArizonaState = 2,
  Arizona = 3,
  Arkansas = 4,
  Auburn = 5,
  Baylor = 6,
  BostonCollege = 7,
  California = 8,
  ClemsonSports = 9,
  ClemsonTigers = 10,
  Colorado = 11,
  Duke = 12,
  Florida = 13,
  FloridaState = 14,
  Georgia = 15,
  GeorgiaTech = 16,
  Illinois = 17,
  Indiana = 18,
  Iowa = 19,
  IowaState = 20,
  Kansas = 21,
  KansasState = 22,
  Kentucky = 23,
  KSR = 24,
  LettermenRow = 25,
  Louisville = 26,
  LSU = 27,
  Maryland = 28,
  Miami = 29,
  MichiganState = 30,
  Michigan = 31,
  Minnesota = 32,
  MississippiState = 33,
  Missouri = 34,
  NCState = 35,
  Nebraska = 36,
  NorthCarolina = 37,
  Northwestern = 38,
  NotreDame = 39,
  OhioState = 40,
  Oklahoma = 41,
  OklahomaState = 42,
  OleMiss = 43,
  On3 = 44,
  Oregon = 45,
  OregonState = 46,
  PennState = 47,
  Pittsburgh = 48,
  Purdue = 49,
  Rutgers = 50,
  SouthCarolina = 51,
  Stanford = 52,
  Syracuse = 53,
  TCU = 54,
  Tennessee = 55,
  TexasAM = 56,
  Texas = 57,
  TexasTech = 58,
  UCLA = 59,
  USC = 60,
  Utah = 61,
  Vanderbilt = 62,
  Virginia = 63,
  VirginiaTech = 64,
  WakeForest = 65,
  Washington = 66,
  WashingtonState = 67,
  WestVirginia = 68,
  Wisconsin = 69,
  BamaOnLine = 72,
  InsideTexas = 73,
  DawgsHQ = 74,
  ScoopDuck = 75,
  AuburnLive = 76,
  WeAreSC = 79,
  TheWolverine = 80,
  BWI = 81,
  TheWolfpacker = 82,
  GatorsOnline = 83,
  AlabamaAM = 84,
  AlabamaState = 85,
  Albany = 86,
  AlcornState = 87,
  AbileneChristian = 88,
  AppalachianState = 89,
  Akron = 90,
  Army = 91,
  AustinPeay = 92,
  ArkansasPineBluff = 93,
  ArkansasLittleRock = 94,
  ArkansasState = 95,
  AirForce = 96,
  BallState = 97,
  American = 98,
  Wofford = 99,
  Winthrop = 100,
  WisconsinMilwaukee = 101,
  WisconsinGreenBay = 102,
  WichitaState = 103,
  WesternCarolina = 104,
  YoungstownState = 105,
  Xavier = 106,
  WrightState = 107,
  WesternIllinois = 108,
  WesternMichigan = 109,
  WesternKentucky = 110,
  Wyoming = 111,
  Yale = 112,
  RobertMorris = 113,
  Pennsylvania = 114,
  JacksonvilleState = 115,
  JacksonState = 116,
  Presbyterian = 117,
  Houston = 118,
  Rice = 119,
  HoustonBaptist = 120,
  PrairieViewAM = 121,
  IncarnateWord = 122,
  IdahoState = 123,
  Idaho = 124,
  HighPoint = 125,
  IllinoisChicago = 126,
  IllinoisState = 127,
  Richmond = 128,
  Hampton = 129,
  Radford = 130,
  HolyCross = 131,
  Harvard = 132,
  Princeton = 133,
  Rider = 134,
  Pepperdine = 135,
  SacramentoState = 136,
  Iona = 137,
  Pacific = 138,
  Portland = 139,
  PortlandState = 140,
  Hawaii = 141,
  IUPUI = 142,
  IPFW = 143,
  IndianaState = 144,
  Jacksonville = 145,
  Hartford = 146,
  Quinnipiac = 147,
  RhodeIsland = 148,
  Providence = 149,
  Howard = 150,
  NorthwesternState = 151,
  NorthTexas = 152,
  NorthCarolinaAT = 153,
  NorthCarolinaCentral = 154,
  Ohio = 155,
  NorthernIllinois = 156,
  OldDominion = 157,
  NorthernIowa = 158,
  Oakland = 159,
  OralRoberts = 160,
  NorthernKentucky = 161,
  NorthDakotaState = 162,
  NorthDakota = 163,
  NorthernColorado = 164,
  NorthernArizona = 165,
  NorthFlorida = 166,
  Lehigh = 167,
  Lafayette = 168,
  LaSalle = 169,
  KennesawState = 170,
  Louisiana = 171,
  LouisianaMonroe = 172,
  LouisianaTech = 173,
  Lamar = 174,
  LoyolaMaryland = 175,
  KentState = 176,
  LoyolaChi = 177,
  Longwood = 178,
  Liberty = 179,
  LoyolaMarymount = 180,
  LongBeachState = 181,
  LIUPost = 182,
  LongIsland = 183,
  Lipscomb = 184,
  Duquesne = 185,
  Elon = 186,
  EastCarolina = 187,
  Davidson = 188,
  Dayton = 189,
  EasternWashington = 190,
  Creighton = 191,
  DePaul = 192,
  EasternIllinois = 193,
  Cornell = 194,
  Drake = 195,
  Detroit = 196,
  EasternMichigan = 197,
  EasternKentucky = 198,
  EastTennesseeState = 199,
  Denver = 200,
  Evansville = 201,
  Dartmouth = 202,
  DelawareState = 203,
  SaintFrancisPA = 204,
  SaintJosephs = 205,
  Samford = 206,
  Mercer = 207,
  SavannahState = 208,
  McNeeseState = 209,
  SouthernUniversity = 210,
  SouthernMiss = 211,
  Maine = 212,
  Marquette = 213,
  StephenFAustin = 214,
  SamHoustonState = 215,
  MarylandEasternShore = 216,
  MiamiOH = 217,
  Seattle = 218,
  SouthernIllinois = 219,
  Massachusetts = 220,
  SaintPeters = 221,
  SanDiego = 222,
  SanDiegoState = 223,
  SanFrancisco = 224,
  StMarys = 225,
  SantaClara = 226,
  SanJoseState = 227,
  Manhattan = 228,
  StFrancisNY = 229,
  StJohns = 230,
  StonyBrook = 231,
  Marist = 232,
  StBonaventure = 233,
  MiddleTennesseeState = 234,
  Memphis = 235,
  SaintLouis = 236,
  Marshall = 237,
  Stetson = 238,
  SouthernUtah = 239,
  SacredHeart = 240,
  SouthAlabama = 241,
  NewOrleans = 242,
  NichollsState = 243,
  SoutheasternLouisiana = 244,
  MississippiValleyState = 245,
  SouthCarolinaState = 246,
  SouthCarolinaUpstate = 247,
  SMU = 248,
  MorganState = 249,
  Navy = 250,
  MountStMarys = 251,
  SouthDakotaState = 252,
  SouthDakota = 253,
  NebraskaOmaha = 254,
  SIUEdwardsville = 255,
  NorfolkState = 256,
  NewMexico = 257,
  NewMexicoState = 258,
  MontanaState = 259,
  Montana = 260,
  SetonHall = 261,
  NJIT = 262,
  Monmouth = 263,
  Siena = 264,
  Niagara = 265,
  MoreheadState = 266,
  MurrayState = 267,
  SoutheastMissouriState = 268,
  MissouriKansasCity = 269,
  MissouriState = 270,
  Nevada = 271,
  NewHampshire = 272,
  GeorgiaState = 273,
  GeorgiaSouthern = 274,
  GramblingState = 275,
  Furman = 276,
  GardnerWebb = 277,
  Gonzaga = 278,
  GeorgeMason = 279,
  FairleighDickinson = 280,
  FresnoState = 281,
  Fordham = 282,
  FloridaAM = 283,
  FIU = 284,
  FloridaAtlantic = 285,
  FloridaGulfCoast = 286,
  Fairfield = 287,
  GeorgeWashington = 288,
  Georgetown = 289,
  Bucknell = 290,
  Villanova = 291,
  UTArlington = 292,
  UTSA = 293,
  UTEP = 294,
  BoiseState = 295,
  Campbell = 296,
  BowlingGreen = 297,
  Bradley = 298,
  VCU = 299,
  VirginiaMilitaryInstitute = 300,
  BostonUniversity = 301,
  CalStateNorthridge = 302,
  CaliforniaBaptist = 303,
  CalStateFullerton = 304,
  CalStateBakersfield = 305,
  CalPoly = 306,
  Wagner = 307,
  Binghamton = 308,
  Canisius = 309,
  Buffalo = 310,
  Vermont = 311,
  Belmont = 312,
  UTMartin = 313,
  Butler = 314,
  Valparaiso = 315,
  BethuneCookman = 316,
  USF = 317,
  UNLV = 318,
  UtahValley = 319,
  UtahState = 320,
  WeberState = 321,
  BYU = 322,
  Brown = 323,
  Bryant = 324,
  Temple = 325,
  UAB = 326,
  Troy = 327,
  Tulane = 328,
  TheCitadel = 329,
  CharlestonSouthern = 330,
  CoastalCarolina = 331,
  TexasSouthern = 332,
  TexasAMCorpusChristi = 333,
  TexasRioGrandeValley = 334,
  TexasState = 335,
  UMBC = 336,
  CoppinState = 337,
  UNCGreensboro = 338,
  Charlotte = 339,
  UNCAsheville = 340,
  Toledo = 341,
  ClevelandState = 342,
  Cincinnati = 343,
  ChicagoState = 344,
  UMassLowell = 345,
  UCRiverside = 346,
  UCIrvine = 347,
  UCSantaBarbara = 348,
  UCDavis = 349,
  Columbia = 350,
  Colgate = 351,
  CentralMichigan = 352,
  Tulsa = 353,
  TennesseeState = 354,
  Chattanooga = 355,
  TennesseeTech = 356,
  CentralArkansas = 357,
  ColoradoState = 358,
  UCF = 359,
  CentralConnecticutState = 360,
  Connecticut = 361,
  OMSpirit = 362,
  BlueAndGold = 363,
  TheBengalTiger = 364,
  OnThePonyExpress = 365,
  GamecockCentral = 366,
  TexasAMAggies = 367,
  NIL = 368,
  TransferPortal = 369,
  HuskerOnline = 370,
  CaneSport = 371,
  Warchant = 372,
  Volquest = 373,
  KStateOnline = 374,
  Outsiderdotcom = 375,
  MaroonAndWhite = 376,
  GoldAndBlack = 377,
  Elite = 380,
  JamesMadison = 381,
  SpartanMag = 382,
  HawkeyeReport = 383,
  Prospex = 384,
  On3OS = 394,
  KSRPlus = 395,
  SoonerScoop = 396,
  FiveGOATs = 397,
  KentuckyWesleyan = 398,
  Bethel = 399,
  Her = 400,
  SoftballAmerica = 401,
  On3HighSchool = 402,
  Deleware = 403,
  Betting = 404,
  Towson = 405,
  Lindenwood = 406,
  Cumberland = 407,
  TheHoosier = 408,
  Recruits = 409,
  GrandCanyon = 410,
  Rivals = 411,
  ASUDevils = 412,
  RivalsFootballRecruiting = 413,
  RivalsBasketballRecruiting = 414,
  HawgBeat = 415,
  GoBlackKnights = 416,
  EagleAction = 417,
  GoldenBearReport = 418,
  TigerIllustrated = 419,
  CUSportsReport = 420,
  DevilsIllustrated = 421,
  JacketsOnline = 422,
  OrangeAndBlueNews = 423,
  CycloneReport = 424,
  JayhawkSlant = 425,
  BleedTechBlue = 426,
  CardinalSports = 427,
  TerrapinSportsReport = 428,
  GophersNation = 429,
  MizzouToday = 430,
  TheMidReport = 431,
  InsideCarolina = 432,
  WildcatReport = 433,
  OStateIllustrated = 434,
  BeaversEdge = 435,
  PittSportsNews = 436,
  TheKnightReport = 437,
  PirateCrew = 438,
  BullsInsider = 439,
  BigGoldNation = 440,
  CardinalSportsReport = 441,
  OwlScoop = 442,
  AggieYell = 443,
  RedRaiderSports = 444,
  InsideTulsaSports = 445,
  UCFSports = 446,
  BruinBlitz = 447,
  TheDOREReport = 448,
  CavsCorner = 449,
  DeaconsIllustrated = 450,
  WVSports = 451,
  BadgerBlitz = 452,
  UGASports = 453,
  CatsIllustrated = 454,
  MaizeAndBlueReview = 455,
  SpartansIllustrated = 456,
  InsideNebraska = 457,
  OUInsider = 458,
  AlabamaHS = 459,
  ArizonaVarsity = 460,
  ColoradoPrepReport = 461,
  FLAVarsity = 462,
  GAVarsity = 463,
  EdgyTim = 464,
  HickoryHusker = 465,
  IowaPreps = 466,
  MarylandVarsity = 467,
  HuskerlandPreps = 468,
  NJHoops = 469,
  NMPreps = 470,
  NYCHoops = 471,
  NorCalPreps = 472,
  NCPreps = 473,
  OhioPreps = 474,
  PAPreps = 475,
  TNVarsity = 476,
  LoneStarPreps = 477,
  VirginiaPreps = 478,
  WashingtonPreps = 479,
  TigerSportsReport = 480,
  WarhawkReport = 481,
  UconnReport = 485,
  UteNation = 486,
  JCGridiron = 487,
}
